import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: []
})
export class EfaactConfigurationModule {
    constructor() {}
}

export enum LoginRequestStatus {
    Undefined = -1,
    LoginSuccessful = 0,
    SubmitUsernamePasswordAndPIN = 1,
    InvalidPIN = 2,
    InvalidUsernameOrPassword = 3,
    NoAccessCodeMethodsAvailable = 4,
    SelectAccessCodeMethod = 5,
    AccessCodeSent = 6,
    InvalidAccessCode = 7,
    NoSecurityQuestionAvailable = 8,
    AnswerSecurityQuestion = 9,
    InvalidSecurityAnswer = 10,
    MaxFailedAttemptsReached = 11
}
